module.exports = __webpack_public_path__ + "static/media/dashboard.dfb59fb6.svg";